import {BaseEntity} from "./BaseEntity";

export class Location implements BaseEntity {
    constructor(public id?: number,
                public name?: string,
                public site?: string,
                public building?: string,
                public floor?: string,
                public room?: string,
                public description?: string,
                public rfidTag?: string,
                public lastModifiedBy?:string) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;
        this.site = json.site;
        this.building = json.building;
        this.floor = json.floor;
        this.room = json.room;
        this.description = json.description;
        this.rfidTag = json.rfidTag;
        this.lastModifiedBy = json.lastModifiedBy;
    }
}
